/**
 * Transforms object with boolean values to array of strings
 */
export const objectBoolToArrayString = <T extends string>(obj: Record<string, boolean>): T[] => {
	const result: T[] = [];

	for (const key in obj) {
		if (obj[key]) {
			result.push(key as T);
		}
	}

	return result;
};
